// extracted by mini-css-extract-plugin
module.exports = {"container":"Frame__container--2C7hs","wrapper":"Frame__wrapper--3y-AQ","header":"Frame__header--1wt11","body":"Frame__body--1uEC0"};